import React from "react";

type Props = {
  children: React.ReactNode;
};

type State = {};

export default class ServiceProviders extends React.Component<Props, State> {
  render = (): React.ReactNode => {
    const { children } = this.props;

    // Any globally accessible service related providers go here!
    // Things like a centralized place for performing auth, logout, etc.
    // Each provider wrapping children here should not care about authentication state.
    return children;
  };
}
